/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Just_Super_Wasp_ScoopInputs */

const fr_just_super_wasp_scoop = /** @type {(inputs: Just_Super_Wasp_ScoopInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ta distance max`)
};

/**

* @param {Just_Super_Wasp_ScoopInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const just_super_wasp_scoop = /** @type {((inputs?: Just_Super_Wasp_ScoopInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Just_Super_Wasp_ScoopInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_just_super_wasp_scoop(inputs)
});